"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateFlow = void 0;
const elements_core_i18n_1 = require("@hydrogen/elements.core.i18n");
const utils_1 = require("./utils");
const getStepPath = (path = '') => {
    if (path.startsWith('/'))
        return path;
    return `/${path}`;
};
const getStepsInfo = (parentLink, steps, t) => (steps
    .filter((step) => (step.isMain))
    .map((step) => ({
    mainStep: step.mainStep,
    link: `${parentLink}${getStepPath(step.url)}`,
    title: (0, utils_1.getTitle)((step === null || step === void 0 ? void 0 : step.mainStepTitle) || '', t),
    label: (0, utils_1.getTitle)((step === null || step === void 0 ? void 0 : step.stepLabel) || '', t),
}))
    .reduce((acc, item) => {
    acc[item.mainStep] = {
        link: item.link,
        title: item.title,
        label: item.label,
    };
    return acc;
}, {}));
const generateFlow = ({ parentLinkPattern, totalSteps, renderStepLayout, homePage = '', steps = [], }) => (steps.map((step) => ({
    url: step.url,
    props: step.props,
    Component: () => {
        var _a;
        const { t } = (0, elements_core_i18n_1.useLanguage)();
        const parentLink = (0, utils_1.generateLinkByPattern)(parentLinkPattern, '');
        if (!((_a = step.withLayout) !== null && _a !== void 0 ? _a : true)) {
            return (typeof step.Component === 'function'
                ? step.Component({ parentLink, homePage })
                : step.Component);
        }
        return (renderStepLayout && renderStepLayout({
            progress: {
                mainStep: step.mainStep,
                stepProgress: step.stepProgress,
                mainStepTitle: (0, utils_1.getTitle)((step === null || step === void 0 ? void 0 : step.mainStepTitle) || '', t),
                subStepTitle: (0, utils_1.getTitle)((step === null || step === void 0 ? void 0 : step.subStepTitle) || '', t),
                stepsInfo: getStepsInfo(parentLink, steps, t),
                totalSteps,
            },
            step: (typeof step.Component === 'function'
                ? step.Component({ parentLink, homePage })
                : step.Component),
        }));
    },
})));
exports.generateFlow = generateFlow;
//# sourceMappingURL=generate-flow.js.map